<template>
    <div class="ku-apply">
        <div class="word">
            <span>非常重要的资金安全</span>
            <label>由中国领先的持牌支付科技公司汇付天下提供支付结算，标准费率0.38%，T+1自动到账，安全又稳定。<br><font>不需要汇付支付的，可以自备pos，只能用收银及厨显功能</font></label>
        </div>

        <Apply />

        <div class="ku-shop-s2">
            <span @click="apply">老版申请</span>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import {Button} from 'vant';

import Apply from "components/apply.vue";
Vue.use(Button);

export default {
    name: "Login",
    components: {
        Apply
    },
    data() {
        return {

        }
    },
    mounted() {
        this.onLoad()
    },
    methods: {
        onLoad() {

        },
        apply() {
            this.$router.push('/apply1')
        },
    },
}
</script>

<style scoped lang="less">
@import "/src/styles/base";
.ku-apply {
    padding: 30px 20px 40px;
    min-height: 100%;
    background: #50AFA7;

    .word {
        background: #fff;
        border: 1px solid #dde5e1;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        padding: 15px;
        text-align: left;
        font-size: 24px;
        margin: 0 20px;
        span {
            color: #26a670;
            display: block;
            font-weight: 800;
            margin-bottom: 6px;
        }
        label {
            color: #5c6661;
            line-height: 1.5;
            font {
                color: #ed891e;
                display: block;
                margin-top: 6px;
            }
        }
    }

    .ku-shop-s2 {
        font-size: 28px;
        color: #ff0;
        line-height: 100px;
        position: fixed;
        bottom: 50px;
        width: 100%;
        span {
            padding: 20px 30px;
            border-radius: 40px;
            background: #0DA195;
            margin: 0 15px;
            &:nth-child(2) {
                color: #ffffff;
            }
        }
    }
}
</style>
